import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { differenceInDays, parseISO } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatBRL(centavos: number): string {
  const reais = centavos / 100;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(reais);
}

export function formatROA(bps: number): string {
  const pct = bps / 100;
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(pct) + '%';
}

export function daysSince(dateStr: string): number {
  try {
    return differenceInDays(new Date(), parseISO(dateStr));
  } catch {
    return 0;
  }
}

export function isStale(lastInteraction: string | null): boolean {
  if (!lastInteraction) return true;
  return daysSince(lastInteraction) > 10;
}

export function brlInputToCents(value: string): number {
  const cleaned = value.replace(/\D/g, '');
  return parseInt(cleaned || '0', 10) * 100;
}

export function centsToBrlInput(centavos: number): string {
  return String(Math.floor(centavos / 100));
}

export function roaPctToInputStr(bps: number): string {
  return (bps / 100).toFixed(2);
}

export function roaInputStrToBps(value: string): number {
  const pct = parseFloat(value.replace(',', '.') || '0');
  return Math.round(pct * 100);
}
